(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('gcc-currency-config').textContent);
  const codes = ['QAR', 'SAR', 'AED', 'KWD', 'BHD', 'OMR', 'GBP', 'USD'];
  const key = 'Teilo-display-currency';
  let rates = config.rates;
  let currency = 'QAR';
  try { const saved = localStorage.getItem(key); if (codes.includes(saved)) currency = saved; } catch {}
  const original = new WeakMap();
  const commaDecimal = config.decimalSample.includes(',');
  const pattern = /(?:QAR|QR)\s*([0-9]+(?:[.,\s\u00a0][0-9]+)*)|([0-9]+(?:[.,\s\u00a0][0-9]+)*)\s*(?:QAR|QR)/g;
  const number = value => Number(commaDecimal ? value.replace(/[.\s\u00a0]/g, '').replace(',', '.') : value.replace(/[,\s\u00a0]/g, ''));
  function render() {
    observer.disconnect();
    document.querySelectorAll('[data-gcc-currency]').forEach(select => {
      select.value = currency;
      const selected = select.selectedOptions[0];
      select.closest('.teilo-menu-country')?.querySelectorAll('[data-gcc-flag]').forEach(flag => { flag.textContent = selected.dataset.flag; });
    });
    document.querySelectorAll('[data-gcc-note]').forEach(note => { note.hidden = currency === 'QAR'; });
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.parentElement?.closest('script,style,textarea,select,[data-gcc-note],svg') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    let node;
    while ((node = walker.nextNode())) {
      const previous = original.get(node);
      const raw = previous && node.data === previous.rendered ? previous.raw : node.data;
      pattern.lastIndex = 0;
      if (!pattern.test(raw)) continue;
      pattern.lastIndex = 0;
      const rendered = currency === 'QAR' ? raw : raw.replace(pattern, (match, before, after) => {
        const amount = number(before || after);
        if (!Number.isFinite(amount)) return match;
        const digits = ['KWD', 'BHD', 'OMR'].includes(currency) ? 3 : 2;
        return currency + ' ' + new Intl.NumberFormat('en', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(amount * rates[currency]);
      });
      original.set(node, { raw, rendered });
      if (node.data !== rendered) node.data = rendered;
    }
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; render(); });
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-gcc-currency]') || !codes.includes(event.target.value)) return;
    currency = event.target.value;
    try { localStorage.setItem(key, currency); } catch {}
    render();
  });
  render();
  // Refresh daily rates; the verified publication-day rates remain a fallback.
  fetch('https://api.frankfurter.dev/v2/rates?base=QAR&quotes=SAR,AED,KWD,BHD,OMR,GBP,USD', { signal: AbortSignal.timeout(5000) })
    .then(response => { if (!response.ok) throw new Error('Rates unavailable'); return response.json(); })
    .then(rows => {
      const fresh = { QAR: 1 };
      for (const row of rows) if (codes.includes(row.quote) && row.base === 'QAR' && Number.isFinite(row.rate) && row.rate > 0) fresh[row.quote] = row.rate;
      if (codes.every(code => fresh[code])) { rates = fresh; render(); }
    }).catch(() => {});
})();
